//#region Imports

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClassForm } from '../../../../../shared/models/interfaces/forms/course-form.interface';
import { VideoEmbedPreview } from '../../../../../shared/helpers/video-embed.helper';
import { CourseContentTypeVideoEmbedComponent } from '../video-embed/course-content-type-video-embed.component';

//#endregion

@Component({
  selector: 'l-course-content-type-youtube',
  standalone: true,
  imports: [CourseContentTypeVideoEmbedComponent],
  template: `
    <l-course-content-type-video-embed
      [form]="form"
      [preview]="preview"
      provider="youtube"
      (previewChange)="previewChange.emit($event)"
    />
  `,
})
export class CourseContentTypeYoutubeComponent {

  //#region Inputs

  @Input({ required: true })
  public form!: FormGroup<ClassForm>;

  @Input()
  public preview: VideoEmbedPreview | null = null;

  //#endregion

  //#region Outputs

  @Output()
  public readonly previewChange = new EventEmitter<VideoEmbedPreview | null>();

  //#endregion

}
